import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
class default_1 extends Component {
    constructor(props) {
        super(props);
        this.handleToggleSection = () => this.setState({ open: !this.state.open });
        this.state = {
            open: true,
        };
    }
    render() {
        const { title, children, dataTestId } = this.props;
        const { open } = this.state;
        const toggleClassName = classnames({
            fa: true,
            'mr-0': true,
            'font-light': true,
            'fa-chevron-right': !open,
            'fa-chevron-down': open,
        });
        const filtersClassName = classnames({
            'filters-list': true,
            'px-4': true,
            'pb-4': true,
            hide: !open,
            'border-b': true,
            'border-grey-light': true,
            'border-solid': true,
        });
        return (React.createElement("div", { "data-testid": dataTestId, className: "list-filter-group" },
            React.createElement("div", { "data-testid": "div-52cda722", className: "heading flex justify-between pt-4 items-center" },
                React.createElement("h4", { "data-testid": "h4-e38f30ab", className: "text-black text-sm m-0 pl-4" }, title),
                React.createElement("button", { "data-testid": "button-0d0dd087", className: "button", onClick: this.handleToggleSection },
                    React.createElement("span", { "data-testid": "span-670a9124", className: toggleClassName }))),
            React.createElement("div", { "data-testid": "div-43ccb11e", className: filtersClassName }, children)));
    }
}
default_1.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
    dataTestId: PropTypes.string,
};
export default default_1;
